<h2 class="mb-5 text-muted">Основни категории</h2>
<ul class="list-unstyled row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 g-col-4 justify-content-center">
  @for (category of popularAdCategories; track category.adCategoryId) {
    <li class="text-center mb-5">
      <a [routerLink]="appRoutes.adList"
         [queryParams]="{adCategoryId: category.adCategoryId}"
         class="category-card-container d-flex flex-column align-items-center text-decoration-none">
        <div class="border border-5 rounded-circle border-light-subtle shadow">
          <div class="category-card">
            <img [src]="'https://collectoria.bg/assets/categories/' + category.adCategoryImageSource"
                 alt="{{ category.adCategoryName }}">
          </div>
        </div>
        <span>{{ category.adCategoryName }}</span>
      </a>
    </li>
  }
</ul>
